export default __webpack_public_path__ + "static/1205-2d9e50feb824cb41e71f5b4740529e01.gif";